// extracted by mini-css-extract-plugin
export default {"Language":"Language_Language__TG6i6"};